import { BookOpenCheck, ChevronDown, FileText, Trophy } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import MobileShell, { BrandFooter } from '../components/MobileShell.jsx';

const emptyForm = { group: 'student', name: '', organization: '', identifier: '', className: '' };

export default function HomePage() {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [form, setForm] = useState(() => {
    try { return { ...emptyForm, ...JSON.parse(localStorage.getItem('quizProfile') || '{}') }; } catch { return emptyForm; }
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => { api('/api/config').then(setConfig).catch(() => setError('系统配置加载失败，请刷新重试')); }, []);
  const organizations = useMemo(() => form.group === 'student' ? config?.colleges : config?.departments, [config, form.group]);

  function update(key, value) {
    setError('');
    setForm((current) => ({ ...current, [key]: value }));
  }

  function changeGroup(group) {
    setForm((current) => ({ ...current, group, organization: '', identifier: '', className: '' }));
    setError('');
  }

  async function startQuiz(event) {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const attempt = await api('/api/quiz/start', { method: 'POST', body: JSON.stringify(form) });
      localStorage.setItem('quizProfile', JSON.stringify(form));
      sessionStorage.setItem('activeAttemptId', attempt.attemptId);
      navigate('/quiz', { state: { attempt } });
    } catch (requestError) {
      setError(requestError.message);
      if (requestError.code === 'ATTEMPT_LIMIT') setTimeout(() => navigate('/leaderboard'), 900);
    } finally {
      setLoading(false);
    }
  }

  return (
    <MobileShell className="home-page">
      <section className="home-hero">
        <div className="hero-kicker">首个民族团结进步宣传周</div>
        <h1>《中华人民共和国民族团结进步促进法》</h1>
        <div className="hero-ribbon">线上知识竞赛</div>
        <p>以法为桥，同心同行</p>
      </section>

      <form className="entry-card" onSubmit={startQuiz}>
        <div className="entry-card-title">
          <span><BookOpenCheck size={19} /></span>
          <div><b>参赛信息</b><small>每人最多答题 2 次，取最高分</small></div>
        </div>
        <div className="group-switch" role="group" aria-label="参赛组别">
          <button type="button" className={form.group === 'student' ? 'active' : ''} onClick={() => changeGroup('student')}>学生</button>
          <button type="button" className={form.group === 'staff' ? 'active' : ''} onClick={() => changeGroup('staff')}>教职工</button>
        </div>

        <label className="form-field">
          <span>姓名</span>
          <input value={form.name} onChange={(event) => update('name', event.target.value)} placeholder="请输入真实姓名" autoComplete="name" />
        </label>
        <label className="form-field select-field">
          <span>{form.group === 'student' ? '学院' : '单位'}</span>
          <select value={form.organization} onChange={(event) => update('organization', event.target.value)}>
            <option value="">请选择{form.group === 'student' ? '所在学院' : '所在单位'}</option>
            {organizations?.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
          <ChevronDown size={17} />
        </label>
        <div className={`field-row ${form.group === 'staff' ? 'one-field' : ''}`}>
          <label className="form-field">
            <span>{form.group === 'student' ? '学号' : '工号'}</span>
            <input value={form.identifier} onChange={(event) => update('identifier', event.target.value)} placeholder={form.group === 'student' ? '请输入学号' : '请输入教职工号'} inputMode={form.group === 'staff' ? 'numeric' : 'text'} maxLength={form.group === 'staff' ? 8 : 20} />
          </label>
          {form.group === 'student' && (
            <label className="form-field">
              <span>班级</span>
              <input value={form.className} onChange={(event) => update('className', event.target.value)} placeholder="如：金融 2401" />
            </label>
          )}
        </div>
        {error && <div className="form-error" role="alert">{error}</div>}
        <button className="primary-button" type="submit" disabled={loading || !config}>{loading ? '正在进入…' : '开始答题'}</button>
        <button className="secondary-button" type="button" onClick={() => navigate('/leaderboard')}><Trophy size={18} />竞赛排行榜</button>
        <a className="secondary-button law-button" href="http://www.npc.gov.cn/c2/c30834/202603/t20260313_453201.html" target="_blank" rel="noopener noreferrer"><FileText size={18} />促进法全文</a>
      </form>

      <BrandFooter />
    </MobileShell>
  );
}
